import { render } from "./UIIcons.vue?vue&type=template&id=4081c6f4"
import script from "./UIIcons.vue?vue&type=script&lang=js"
export * from "./UIIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__